import { render, staticRenderFns } from "./EmailActivated.vue?vue&type=template&id=617c0c30&scoped=true"
import script from "./EmailActivated.vue?vue&type=script&lang=js"
export * from "./EmailActivated.vue?vue&type=script&lang=js"
import style0 from "./EmailActivated.vue?vue&type=style&index=0&id=617c0c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617c0c30",
  null
  
)

export default component.exports